export const iconFontAwesomePunctuationSymbolsAt = (
	<i className="fa-solid fa-at"></i>
);
